import { Grid, makeStyles, Paper } from '@material-ui/core';
import { isArray } from 'lodash';
import { Children, Divider, Heading, TextBlock } from 'neon-design-system';
import { Fragment } from 'react';

const useStyles = makeStyles((theme) => ({
  offsetTop: ({ offsetTop }: ItemListProps) => ({
    marginTop: offsetTop ? theme.spacing(2) : 0
  }),
  paper: {
    padding: theme.spacing(2)
  },
  dividerOffset: {
    margin: theme.spacing(1, 0)
  }
}));

interface ItemListProps {
  title?: string;
  subtitle?: string;
  children: Children;
  offsetTop?: boolean;
  contentClassName?: string;
}

export const ItemsList = (props: ItemListProps) => {
  const { title, subtitle, children, contentClassName } = props;
  const classes = useStyles(props);
  const items = isArray(children) ? children : [children];
  return (
    <>
      {(title || subtitle) && (
        <Grid item xs={12} className={classes.offsetTop}>
          {title && (
            <Heading styleName="title1" xs="small">
              {title}
            </Heading>
          )}
          {subtitle && (
            <TextBlock xs="small" ink="muted">
              {subtitle}
            </TextBlock>
          )}
        </Grid>
      )}
      <Grid item xs={12} className={contentClassName}>
        <Paper className={classes.paper}>
          {items.filter(Boolean).map((element, index) => (
            <Fragment key={index}>
              {index > 0 && <Divider className={classes.dividerOffset} />}
              {element}
            </Fragment>
          ))}
        </Paper>
      </Grid>
    </>
  );
};
